import type { JSX } from 'react';
import { useStore } from '@/state/store';
import { Panel, Row } from '@/components/ui/Panel';

export function PerformancePanel(): JSX.Element | null {
  const show = useStore((s) => s.view.showDebugPanel);
  const fps = useStore((s) => s.fps);
  const frame = useStore((s) => s.frame);
  if (!show) return null;
  return (
    <Panel title="Performance">
      <Row label="Render FPS" value={fps.toFixed(0)} tone={fps > 45 ? 'ok' : 'warn'} />
      <Row
        label="Solve time"
        value={frame ? `${frame.solveMilliseconds.toFixed(2)} ms` : '—'}
        tone={frame && frame.solveMilliseconds > 16 ? 'warn' : undefined}
      />
      <Row label="Solver iterations" value={frame?.compliant?.iterations ?? frame?.rigid?.iterations ?? '—'} />
      <Row label="Vertices" value={frame?.meshStats.vertices ?? '—'} />
      <Row label="Triangles" value={frame?.meshStats.triangles ?? '—'} />
      <Row label="Collision pairs" value={frame?.collisionCount ?? 0} />
      <p className="note">
        Solving runs in a Web Worker with at most one step in flight. When the solver cannot keep up,
        the simulation rate drops and the render loop keeps running - the interface never blocks on
        numerics.
      </p>
    </Panel>
  );
}
